import { NavbarProvider } from '@/providers/NavbarProvider';
import * as Sentry from '@sentry/react';
import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router';
import { appRoutes } from '.';
import Loading from '../shared/components/Loading';
import { ROUTES } from './constants';
import { renderRoutes } from './utils/renderRoutes';

const NotFound = lazy(() => import('../pages/NotFound/Index'));

const Layout = lazy(() => import('../layout'));

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export default function AppRoutes() {
  const layoutRoutes = appRoutes.filter((route) => route.path !== ROUTES.NOT_FOUND.path);

  return (
    <NavbarProvider>
      <Suspense
        fallback={
          <div className="flex h-screen w-screen items-center justify-center">
            <Loading size="lg" />
          </div>
        }
      >
        <SentryRoutes>
          {/* Routes with Layout (sidebar, header, footer) */}
          <Route path="/" element={<Layout />}>
            {renderRoutes(layoutRoutes)}
          </Route>

          {/* NotFound route without Layout */}
          <Route path={ROUTES.NOT_FOUND.path} element={<NotFound />} />
        </SentryRoutes>
      </Suspense>
    </NavbarProvider>
  );
}
